import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createHomework } from '@services/registry';

export function useCreateHomework({ tenantId }) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ payload, createdBy }) => {
            return await createHomework({ tenantId, payload, createdBy });
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['homeworks', tenantId] });
        },
    });
}
